module.exports = __webpack_public_path__ + "static/media/5_Museum Tower Kyobashi - Tokyo.ff502eef.jpg";